// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

:root {
  --logo-primary: rgb(26, 52, 96);
  --logo-secondary: rgb(242, 242, 242);
  --logo-primary-op: rgba(26, 52, 96, 0.9)
}

body {
  background-color: var(--logo-secondary);
}

.content-container {
  min-height: calc(100vh - 92px);
}

/* -----HEADER----- */

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--logo-primary);
  box-shadow: 0 2px 10px black;
  overflow: hidden;
}

.logo {
  width: 150px;
  padding: 10px;
}

.header-nav {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.header-text {
  text-decoration: none;
  padding: 20px;
  color: var(--logo-secondary);
  font-weight: bold;
  font-size: large;
  transition: box-shadow 0.3s ease-in-out;
  border-radius: 15px;
  margin: 10px;
}

.phone-icon {
  display: flex;
  flex-direction: row;
}

.phone-icon > a {
  text-decoration: none;
  color: inherit
}

.header-nav > a:hover , .header-nav > div:hover{
  box-shadow: 0 2px 5px rgba(242, 242, 242, 0.3);
}

.mobile-header-wrap {
  display: flex;
  flex-direction: row;
}

.hamburger-wrapper {
  display: flex;
  align-items: center;
}

.hide-me {
  display: none;
}

.show-me {
  display: block;
}

.header-text.active {
  background-color: var(--logo-secondary);
  color: var(--logo-primary);
}

/* -----HOME----- */

.main-wrapper {
  margin: auto;
}

.main {
  display: flex;
  flex-direction: column;
  margin: 40px;
}

.main-h1 {
  text-align: center;
  margin-bottom: 10px;
  font-size: 50px;
  letter-spacing: 1px;
  color: var(--logo-primary)
}

.main-h4-image-div {
  display: flex;
  flex-direction: row;
  padding: 20px 40px;
  line-height: 2em;
}

.main-image-div {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.main-h4 {
  padding-left: 40px;
  font-size: 1.4em;
}

.main-button-div {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.main-button {
  height: -moz-fit-content;
  height: fit-content;
  padding: 20px;
  border: none;
  border-radius: 15px;
  background-color: var(--logo-primary);
  color: var(--logo-secondary);
  font-weight: bold;
  font-size: 20px;
  transition: box-shadow 0.3s ease-in-out;
}

.main-button:hover {
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(242, 242, 242, 0.3);
}

#consultation:hover {
  box-shadow: 0 4px 5px rgba(02, 0, 0, 0.3);
}

.main-image {
  border-radius: 15px;
  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.2);
}

/* ----HOME: CONTACT----- */
#contact-wrapper {
  width: 60%;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 40px;
  padding: 40px 40px 10px 40px;
  background-color: var(--logo-primary-op);
  color: var(--logo-secondary);
  font-weight: bold;
  border-radius: 15px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

#contact-wrapper > h2 {
  text-align: center;
}

#contact-wrapper > form {
  display: flex;
  flex-direction: column;
}

.first-last-name, .email-phone {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.firstname, .lastname, .email, .phone, .message{
  display: flex;
  flex-direction: column;
}

.message {
  width: 80%;
  margin: auto;
}

.firstname > label, .lastname > label, .email > label, .phone > label, .message > label {
  margin-bottom: 10px;
  margin-top: 20px;
}

.firstname > input, .lastname > input, .email > input, .phone > input {
  padding: 10px;
  width: 250px;
  border: none;
  background-color: var(--input-bckgnd);
  border: none;
  border-bottom: 2px solid var(--logo-secondary);
  color: white;
  font-size: large;
}

.message > textarea {
  background-color: var(--input-bckgnd);
  border: 2px solid var(--logo-secondary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
  sans-serif;;
  color: white;
  font-size: large;
}

.submit-btn-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* text-align: center; */
  margin-top: 30px;
  margin-bottom: 20px;
}

.terms-div {
  margin-bottom: 30px;
  width: 75%;
}

.contact-input {
  margin-right: 5px
}

/* -----ABOUT ME----- */

.about-me-wrapper {
  margin: 40px;
}

.about-me-body {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}

.about-me-paragraphs {
  padding: 0 30px 30px 30px;
  margin-top: 20px;
  width: 100%;
}

.about-me-paragraphs > p {
  margin-bottom: 20px;
  font-size: 1.35em;
  font-weight: 500;
  line-height: 1.35em;
}

.about-me-details-wrapper-v {
  margin-top: 20px;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  background-color: var(--logo-primary-op);
  border-radius: 15px;
  width: 35%;
}

.about-me-details-wrapper-v div:nth-child(1) {
  margin-top: 16px;
}

.about-me-details-wrapper-v div:last-child {
  margin-bottom: 16px;
}

.about-me-details-wrapper-h {
  margin-top: 20px;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* background-color: var(--logo-primary-op); */
  border-radius: 15px;
  justify-content: space-evenly;
}

.about-me-details-v {
  /* box-shadow: 0 4px 8px 0 rgba(26, 52, 96, 0.2); */
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2);
  transition: 0.3s;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 8px 16px;
  background-color: white;
  width: 100%;
}

.about-me-details-h {
  /* box-shadow: 0 4px 8px 0 rgba(26, 52, 96, 0.2); */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 16px;
  background-color: white;
  width: 40%;
}

.about-me-details-v:hover {
  box-shadow: 0 8px 16px 0 rgba(255, 255, 255, 0.2);
}

.about-me-details-h:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
}

.about-me-details-v, .about-me-details-h > h2 {
  padding-top: 25px;
  color: var(--logo-primary);
}

.one-about-me-detail-wrapper {
  padding: 30px;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
}

ul {
  margin-left: 10px;
}

li {
  margin-bottom: 5px;
  font-size: 1.1em;
  line-height: 1.25em;
}

.strong {
  font-weight: bold;
}

.indent {
  margin-left: 15px
}

.padding-bottom {
  padding-bottom: 5px;
}

/* -----FOOTER----- */
.footer {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 10px;
  background-color: var(--logo-primary);
  color: var(--logo-secondary);
}

.footer-nav-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer > div > nav > a, .footer > div > nav > div > a, .email-div > a {
  text-decoration: none;
  color: var(--logo-secondary);
  font-size: small;
}

.footer-nav-1 {
  line-height: 1.5em;
}

.footer-nav-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.hours-div, .phone-div > a, .email-div > a {
  font-size: small;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px
}

.location-div > a {
  font-size: small;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 5px
}

.copyright {
  font-size: x-small;
  text-align: center;
  margin-top: 10px;
}

/* -----MEDIA QUERIES----- */

@media screen and (max-width: 599px){
  
  .header-nav-top {
    display: flex;
    flex-direction: row;
    width: 100vw;
    justify-content: space-between;
  }

  .hamburger-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  
  .header.is-open {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-nav {
    display: none;
  }

  .header-nav.is-open {
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }

  .header-nav.is-open > .header-text {
    padding: 10px;
    margin: 5px;
  }

  .hamburger-nav {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .hamburger {
    padding: 30px;
  }

  .hamburger.hide-me {
    padding: 0;
  }

  .hamburger :hover {
    cursor: pointer;;
  }
  
  .main-h4-image-div {
    padding: 10px;
  }

  .main-h4 {
    padding: 0px;
  }

  .main-image-div {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .main-image {
    margin-bottom: 25px;
    width: 100%;
  }

  .main-button-div {
    margin-top: 10px;
  }

  .main-button {
    margin: 20px 0px
  }

  #contact-wrapper {
    width: 70%;
    padding: 40px 20px 0px 20px
  }

  #contact-wrapper > h2 {
    margin-bottom: 20px;
  }

  .first-last-name, .email-phone {
    display: flex;
    flex-direction: column;
    margin: auto;
  }

  .message {
    width: 100%
  }

  .about-me-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    /* margin: 10px; */
    width: 90%;
  }

  .about-me-wrapper > .main-h1 {
    margin-top: 40px;
  }

  .about-me-body {
    flex-direction: column-reverse;
    align-items: center;
    width: 90%;
  }

  .about-me-details-wrapper-v {
    width: -moz-fit-content;
    width: fit-content;
  }

  .about-me-details-wrapper-h {
    margin-top: 0px;
  }

  .about-me-details-v, .about-me-details-h {
    width: 90%
  }

  .about-me-paragraphs {
    padding-top: 20px;
    padding-bottom: 0px
  }

  .footer-nav-wrapper {
    flex-direction: column-reverse;
    align-items: center;
  }

  .footer-nav-wrapper > nav > div {
    margin-bottom: 5px;
  }

  .footer-nav-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1099px){

  .header-nav-top {
    display: flex;
    flex-direction: row;
    width: 100vw;
    justify-content: space-between;
  }

  .hamburger-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  
  .header.is-open {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header-nav {
    display: none;
  }

  .header-nav.is-open {
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
  }

  .header-nav.is-open > .header-text {
    padding: 10px;
    margin: 5px;
  }

  .hamburger-nav {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .hamburger {
    padding: 30px;
  }

  .hamburger.hide-me {
    padding: 0;
  }

  .hamburger :hover {
    cursor: pointer;;
  }

  .main-image-div {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .main-image {
    margin-bottom: 25px;
  }

  .main-button {
    margin: 20px 0px
  }

  #contact-wrapper {
    width: 70%;
  }

  #contact-wrapper > h2 {
    margin-bottom: 20px;
  }

  .first-last-name, .email-phone {
    display: flex;
    flex-direction: column;
    margin: auto;
  }

  .message {
    width: 100%
  }

  .about-me-body {
    flex-direction: column-reverse;
    align-items: center;
  }

  .about-me-details-wrapper-v {
    width: 50%;
  }

  .about-me-details-v {
    width:100%;
  }

  .about-me-paragraphs {
    width: 90%;
    margin-top: 50px;
    padding-bottom: 0px;
  }

  .about-me-details-wrapper-h {
    width: 100%;
  }

  .about-me-details-h {
    width: 90%;
  }

}

@media only screen and (min-width: 1100px) {
  .main-wrapper {
    width: 90%; 
  }

  .main-image-div {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
  }

  .main-button {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  #contact-wrapper {
    width: 50%;
  }

}

@media only screen and (min-width: 1350px) {
  .main-wrapper {
    width: 80%; 
  }

  .main-image-div {
    margin-top: 20px;
  }

  #contact-wrapper {
    width: 50%;
  }

}

@media only screen and (min-width: 1500px) {
  .main-wrapper, .about-me-wrapper {
    width: 70%;
    margin: auto;
  }

  .about-me-wrapper > .main-h1 {
    margin-top: 40px;
  }

  #contact-wrapper {
    width: 50%
  }

}

@media only screen and (min-width: 1700px) {
  .main-wrapper, .about-me-wrapper {
    width: 50%;
  }

  .main-image-div {
    /* flex-direction: column; */
  }
  
  .main-image {
    margin-bottom: 40px;
  }

  .about-me-wrapper > .main-h1 {
    margin-top: 40px;
  }

  #contact-wrapper {
    width: 35%
  }
}

@media only screen and (min-width: 1701px) and (max-width: 2199px) {
  .main-wrapper, .about-me-wrapper {
    width: 60%;
  }
  .about-me-wrapper > .main-h1 {
    margin-top: 40px;
  }
}

@media only screen and (min-width: 2200px) {

  .main-image-div {
    /* flex-direction: column; */
  }
  
  .main-image {
    margin-bottom: 40px;
  }

  #contact-wrapper {
    width: 25%
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;;AAErB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA,mBAAmB;;AAEnB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,wCAAwC;EACxC,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,8CAA8C;EAC9C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC;;YAEU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA,uBAAuB;;AAEvB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mDAAmD;EACnD,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4BAA4B;;AAE5B;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;IACV;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;EACF;;EAEA;IACE,iBAAiB;IACjB;EACF;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE;EACF;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;EACF;;AAEF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;EACF;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --logo-primary: rgb(26, 52, 96);\n  --logo-secondary: rgb(242, 242, 242);\n  --logo-primary-op: rgba(26, 52, 96, 0.9)\n}\n\nbody {\n  background-color: var(--logo-secondary);\n}\n\n.content-container {\n  min-height: calc(100vh - 92px);\n}\n\n/* -----HEADER----- */\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--logo-primary);\n  box-shadow: 0 2px 10px black;\n  overflow: hidden;\n}\n\n.logo {\n  width: 150px;\n  padding: 10px;\n}\n\n.header-nav {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.header-text {\n  text-decoration: none;\n  padding: 20px;\n  color: var(--logo-secondary);\n  font-weight: bold;\n  font-size: large;\n  transition: box-shadow 0.3s ease-in-out;\n  border-radius: 15px;\n  margin: 10px;\n}\n\n.phone-icon {\n  display: flex;\n  flex-direction: row;\n}\n\n.phone-icon > a {\n  text-decoration: none;\n  color: inherit\n}\n\n.header-nav > a:hover , .header-nav > div:hover{\n  box-shadow: 0 2px 5px rgba(242, 242, 242, 0.3);\n}\n\n.mobile-header-wrap {\n  display: flex;\n  flex-direction: row;\n}\n\n.hamburger-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.hide-me {\n  display: none;\n}\n\n.show-me {\n  display: block;\n}\n\n.header-text.active {\n  background-color: var(--logo-secondary);\n  color: var(--logo-primary);\n}\n\n/* -----HOME----- */\n\n.main-wrapper {\n  margin: auto;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  margin: 40px;\n}\n\n.main-h1 {\n  text-align: center;\n  margin-bottom: 10px;\n  font-size: 50px;\n  letter-spacing: 1px;\n  color: var(--logo-primary)\n}\n\n.main-h4-image-div {\n  display: flex;\n  flex-direction: row;\n  padding: 20px 40px;\n  line-height: 2em;\n}\n\n.main-image-div {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.main-h4 {\n  padding-left: 40px;\n  font-size: 1.4em;\n}\n\n.main-button-div {\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n}\n\n.main-button {\n  height: fit-content;\n  padding: 20px;\n  border: none;\n  border-radius: 15px;\n  background-color: var(--logo-primary);\n  color: var(--logo-secondary);\n  font-weight: bold;\n  font-size: 20px;\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.main-button:hover {\n  cursor: pointer;\n  box-shadow: 0 2px 5px rgba(242, 242, 242, 0.3);\n}\n\n#consultation:hover {\n  box-shadow: 0 4px 5px rgba(02, 0, 0, 0.3);\n}\n\n.main-image {\n  border-radius: 15px;\n  box-shadow: 0 4px 10px 0 rgba(0,0,0,0.2);\n}\n\n/* ----HOME: CONTACT----- */\n#contact-wrapper {\n  width: 60%;\n  margin: auto;\n  margin-top: 40px;\n  margin-bottom: 40px;\n  padding: 40px 40px 10px 40px;\n  background-color: var(--logo-primary-op);\n  color: var(--logo-secondary);\n  font-weight: bold;\n  border-radius: 15px;\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n}\n\n#contact-wrapper > h2 {\n  text-align: center;\n}\n\n#contact-wrapper > form {\n  display: flex;\n  flex-direction: column;\n}\n\n.first-last-name, .email-phone {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.firstname, .lastname, .email, .phone, .message{\n  display: flex;\n  flex-direction: column;\n}\n\n.message {\n  width: 80%;\n  margin: auto;\n}\n\n.firstname > label, .lastname > label, .email > label, .phone > label, .message > label {\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.firstname > input, .lastname > input, .email > input, .phone > input {\n  padding: 10px;\n  width: 250px;\n  border: none;\n  background-color: var(--input-bckgnd);\n  border: none;\n  border-bottom: 2px solid var(--logo-secondary);\n  color: white;\n  font-size: large;\n}\n\n.message > textarea {\n  background-color: var(--input-bckgnd);\n  border: 2px solid var(--logo-secondary);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n  'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n  sans-serif;;\n  color: white;\n  font-size: large;\n}\n\n.submit-btn-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* text-align: center; */\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.terms-div {\n  margin-bottom: 30px;\n  width: 75%;\n}\n\n.contact-input {\n  margin-right: 5px\n}\n\n/* -----ABOUT ME----- */\n\n.about-me-wrapper {\n  margin: 40px;\n}\n\n.about-me-body {\n  display: flex;\n  flex-direction: row;\n  margin-top: 30px;\n}\n\n.about-me-paragraphs {\n  padding: 0 30px 30px 30px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.about-me-paragraphs > p {\n  margin-bottom: 20px;\n  font-size: 1.35em;\n  font-weight: 500;\n  line-height: 1.35em;\n}\n\n.about-me-details-wrapper-v {\n  margin-top: 20px;\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  background-color: var(--logo-primary-op);\n  border-radius: 15px;\n  width: 35%;\n}\n\n.about-me-details-wrapper-v div:nth-child(1) {\n  margin-top: 16px;\n}\n\n.about-me-details-wrapper-v div:last-child {\n  margin-bottom: 16px;\n}\n\n.about-me-details-wrapper-h {\n  margin-top: 20px;\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  /* background-color: var(--logo-primary-op); */\n  border-radius: 15px;\n  justify-content: space-evenly;\n}\n\n.about-me-details-v {\n  /* box-shadow: 0 4px 8px 0 rgba(26, 52, 96, 0.2); */\n  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2);\n  transition: 0.3s;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 8px 16px;\n  background-color: white;\n  width: 100%;\n}\n\n.about-me-details-h {\n  /* box-shadow: 0 4px 8px 0 rgba(26, 52, 96, 0.2); */\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 16px;\n  background-color: white;\n  width: 40%;\n}\n\n.about-me-details-v:hover {\n  box-shadow: 0 8px 16px 0 rgba(255, 255, 255, 0.2);\n}\n\n.about-me-details-h:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)\n}\n\n.about-me-details-v, .about-me-details-h > h2 {\n  padding-top: 25px;\n  color: var(--logo-primary);\n}\n\n.one-about-me-detail-wrapper {\n  padding: 30px;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  text-align: left;\n}\n\nul {\n  margin-left: 10px;\n}\n\nli {\n  margin-bottom: 5px;\n  font-size: 1.1em;\n  line-height: 1.25em;\n}\n\n.strong {\n  font-weight: bold;\n}\n\n.indent {\n  margin-left: 15px\n}\n\n.padding-bottom {\n  padding-bottom: 5px;\n}\n\n/* -----FOOTER----- */\n.footer {\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 20px;\n  padding-bottom: 10px;\n  background-color: var(--logo-primary);\n  color: var(--logo-secondary);\n}\n\n.footer-nav-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.footer > div > nav > a, .footer > div > nav > div > a, .email-div > a {\n  text-decoration: none;\n  color: var(--logo-secondary);\n  font-size: small;\n}\n\n.footer-nav-1 {\n  line-height: 1.5em;\n}\n\n.footer-nav-2 {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.hours-div, .phone-div > a, .email-div > a {\n  font-size: small;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px\n}\n\n.location-div > a {\n  font-size: small;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  gap: 5px\n}\n\n.copyright {\n  font-size: x-small;\n  text-align: center;\n  margin-top: 10px;\n}\n\n/* -----MEDIA QUERIES----- */\n\n@media screen and (max-width: 599px){\n  \n  .header-nav-top {\n    display: flex;\n    flex-direction: row;\n    width: 100vw;\n    justify-content: space-between;\n  }\n\n  .hamburger-wrapper {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .header.is-open {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .header-nav {\n    display: none;\n  }\n\n  .header-nav.is-open {\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n\n  .header-nav.is-open > .header-text {\n    padding: 10px;\n    margin: 5px;\n  }\n\n  .hamburger-nav {\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .hamburger {\n    padding: 30px;\n  }\n\n  .hamburger.hide-me {\n    padding: 0;\n  }\n\n  .hamburger :hover {\n    cursor: pointer;;\n  }\n  \n  .main-h4-image-div {\n    padding: 10px;\n  }\n\n  .main-h4 {\n    padding: 0px;\n  }\n\n  .main-image-div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .main-image {\n    margin-bottom: 25px;\n    width: 100%;\n  }\n\n  .main-button-div {\n    margin-top: 10px;\n  }\n\n  .main-button {\n    margin: 20px 0px\n  }\n\n  #contact-wrapper {\n    width: 70%;\n    padding: 40px 20px 0px 20px\n  }\n\n  #contact-wrapper > h2 {\n    margin-bottom: 20px;\n  }\n\n  .first-last-name, .email-phone {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n  }\n\n  .message {\n    width: 100%\n  }\n\n  .about-me-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: auto;\n    /* margin: 10px; */\n    width: 90%;\n  }\n\n  .about-me-wrapper > .main-h1 {\n    margin-top: 40px;\n  }\n\n  .about-me-body {\n    flex-direction: column-reverse;\n    align-items: center;\n    width: 90%;\n  }\n\n  .about-me-details-wrapper-v {\n    width: fit-content;\n  }\n\n  .about-me-details-wrapper-h {\n    margin-top: 0px;\n  }\n\n  .about-me-details-v, .about-me-details-h {\n    width: 90%\n  }\n\n  .about-me-paragraphs {\n    padding-top: 20px;\n    padding-bottom: 0px\n  }\n\n  .footer-nav-wrapper {\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n\n  .footer-nav-wrapper > nav > div {\n    margin-bottom: 5px;\n  }\n\n  .footer-nav-1 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 1099px){\n\n  .header-nav-top {\n    display: flex;\n    flex-direction: row;\n    width: 100vw;\n    justify-content: space-between;\n  }\n\n  .hamburger-wrapper {\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .header.is-open {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .header-nav {\n    display: none;\n  }\n\n  .header-nav.is-open {\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n\n  .header-nav.is-open > .header-text {\n    padding: 10px;\n    margin: 5px;\n  }\n\n  .hamburger-nav {\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .hamburger {\n    padding: 30px;\n  }\n\n  .hamburger.hide-me {\n    padding: 0;\n  }\n\n  .hamburger :hover {\n    cursor: pointer;;\n  }\n\n  .main-image-div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .main-image {\n    margin-bottom: 25px;\n  }\n\n  .main-button {\n    margin: 20px 0px\n  }\n\n  #contact-wrapper {\n    width: 70%;\n  }\n\n  #contact-wrapper > h2 {\n    margin-bottom: 20px;\n  }\n\n  .first-last-name, .email-phone {\n    display: flex;\n    flex-direction: column;\n    margin: auto;\n  }\n\n  .message {\n    width: 100%\n  }\n\n  .about-me-body {\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n\n  .about-me-details-wrapper-v {\n    width: 50%;\n  }\n\n  .about-me-details-v {\n    width:100%;\n  }\n\n  .about-me-paragraphs {\n    width: 90%;\n    margin-top: 50px;\n    padding-bottom: 0px;\n  }\n\n  .about-me-details-wrapper-h {\n    width: 100%;\n  }\n\n  .about-me-details-h {\n    width: 90%;\n  }\n\n}\n\n@media only screen and (min-width: 1100px) {\n  .main-wrapper {\n    width: 90%; \n  }\n\n  .main-image-div {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .main-button {\n    margin-bottom: 20px;\n    margin-top: 20px;\n  }\n\n  #contact-wrapper {\n    width: 50%;\n  }\n\n}\n\n@media only screen and (min-width: 1350px) {\n  .main-wrapper {\n    width: 80%; \n  }\n\n  .main-image-div {\n    margin-top: 20px;\n  }\n\n  #contact-wrapper {\n    width: 50%;\n  }\n\n}\n\n@media only screen and (min-width: 1500px) {\n  .main-wrapper, .about-me-wrapper {\n    width: 70%;\n    margin: auto;\n  }\n\n  .about-me-wrapper > .main-h1 {\n    margin-top: 40px;\n  }\n\n  #contact-wrapper {\n    width: 50%\n  }\n\n}\n\n@media only screen and (min-width: 1700px) {\n  .main-wrapper, .about-me-wrapper {\n    width: 50%;\n  }\n\n  .main-image-div {\n    /* flex-direction: column; */\n  }\n  \n  .main-image {\n    margin-bottom: 40px;\n  }\n\n  .about-me-wrapper > .main-h1 {\n    margin-top: 40px;\n  }\n\n  #contact-wrapper {\n    width: 35%\n  }\n}\n\n@media only screen and (min-width: 1701px) and (max-width: 2199px) {\n  .main-wrapper, .about-me-wrapper {\n    width: 60%;\n  }\n  .about-me-wrapper > .main-h1 {\n    margin-top: 40px;\n  }\n}\n\n@media only screen and (min-width: 2200px) {\n\n  .main-image-div {\n    /* flex-direction: column; */\n  }\n  \n  .main-image {\n    margin-bottom: 40px;\n  }\n\n  #contact-wrapper {\n    width: 25%\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
